<template>
    <nav
        v-show="isNavBarVisible"
        class="top-nav top-0 left-0 right-0 fixed flex bg-white h-14 border-b border-gray-100 z-30 w-screen transition-all xl:pl-60 lg:w-auto lg:items-stretch"
        :class="{'ml-60':isAsideMobileExpanded}"
    >
        <div class="flex-1 items-stretch flex h-14">
            <nav-bar-item type="flex xl:hidden" @click.prevent="menuOpenLg">
                <icon :path="mdiMenu" size="24"/>
            </nav-bar-item>
        </div>

        <div class="flex-none items-stretch flex h-14 lg:hidden">
            <nav-bar-item class="items-center flex" @click.prevent="menuNavBarToggle">
                <icon :path="menuNavBarToggleIcon" size="24"/>
            </nav-bar-item>
        </div>
        <div
            class="absolute w-screen top-14 left-0 bg-white border-b border-gray-100 shadow
        lg:w-auto lg:items-stretch lg:flex lg:flex-grow lg:static lg:border-b-0 lg:overflow-visible lg:shadow-none"
            :class="{ 'hidden': !isMenuNavBarActive, 'block': isMenuNavBarActive }"
        >
            <div
                class="max-h-screen-menu overflow-y-auto lg:overflow-visible lg:flex lg:items-stretch lg:justify-end lg:ml-auto"
            >
                <nav-bar-menu has-divider>
                    <div>
                        <span>{{ $page.props.auth.user.name }}</span>
                    </div>

                    <template #dropdown>
                        <BreezeDropdownLink :href="route('logout')" method="post" as="button">
                            <nav-bar-item-label :icon="mdiLogout" :label="__('Logout')"/>
                        </BreezeDropdownLink>
                    </template>
                </nav-bar-menu>
            </div>
        </div>
    </nav>
</template>

<script>
import {computed, ref} from 'vue'
import {
    mdiForwardburger,
    mdiBackburger,
    mdiClose,
    mdiDotsVertical,
    mdiMenu,
    mdiClockOutline,
    mdiCloud,
    mdiCrop,
    mdiAccount,
    mdiCogOutline,
    mdiEmail,
    mdiLogout,
    mdiGithub
} from '@mdi/js'
import NavBarItem from '@/Components/Dashboard/NavBarItem'
import NavBarItemLabel from '@/Components/Dashboard/NavBarItemLabel'
import NavBarMenu from '@/Components/Dashboard/NavBarMenu'
import NavBarMenuDivider from '@/Components/Dashboard/NavBarMenuDivider'
import UserAvatar from '@/Components/Dashboard/UserAvatar'
import Icon from '@/Components/Dashboard/Icon'
import BreezeDropdownLink from '@/Components/DropdownLink.vue'

export default {
    name: 'NavBar',
    components: {
        UserAvatar,
        NavBarMenu,
        NavBarItem,
        BreezeDropdownLink,
        NavBarItemLabel,
        NavBarMenuDivider,
        Icon
    },
    setup() {

        const isNavBarVisible = true

        const isAsideMobileExpanded = false

        const userName = computed(() => 'Example username')

        const menuToggleMobileIcon = computed(() => isAsideMobileExpanded.value ? mdiBackburger : mdiForwardburger)

        const isMenuNavBarActive = ref(false)

        const menuNavBarToggleIcon = computed(() => isMenuNavBarActive.value ? mdiClose : mdiDotsVertical)

        const menuNavBarToggle = () => {
            isMenuNavBarActive.value = !isMenuNavBarActive.value
        }

        const menuOpenLg = () => {
            document.body.classList.toggle('open-sidebar');
        }

        return {
            isNavBarVisible,
            isAsideMobileExpanded,
            userName,
            menuToggleMobileIcon,
            isMenuNavBarActive,
            menuNavBarToggleIcon,
            menuNavBarToggle,
            menuOpenLg,
            mdiMenu,
            mdiClockOutline,
            mdiCloud,
            mdiCrop,
            mdiAccount,
            mdiCogOutline,
            mdiEmail,
            mdiLogout,
            mdiGithub
        }
    }
}
</script>
